import { useContentBundle } from '@/hooks/useContentBundle'

export function useTourSteps() {
  const { data: bundle, isLoading, isError } = useContentBundle()
  return {
    data: bundle?.tourSteps,
    isLoading,
    isError,
  }
}
